import { render, staticRenderFns } from "./VideoTable.vue?vue&type=template&id=f73f0c2e"
import script from "./VideoTable.vue?vue&type=script&lang=js"
export * from "./VideoTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports